module.exports = __webpack_public_path__ + "img/bell.4c686e25.svg";